// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'merc-header-base',
  templateUrl: './header-base.component.html',
  styleUrls: ['./header-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
